/* CollectiveCubed — global.js
   Lightweight, no dependencies. Handles: AJAX add to cart, cart line updates,
   quantity steppers, variant selection, toast notifications. */

(function () {
  'use strict';

  var toastTimer;

  function toast(message, isError) {
    var el = document.getElementById('cc-toast');
    if (!el) return;
    el.querySelector('.cc-toast__text').textContent = message;
    el.classList.toggle('cc-toast--error', !!isError);
    el.querySelector('.cc-toast__link').hidden = !!isError;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return window.ccMoneyFormat
      ? window.ccMoneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
      : '$' + amount;
  }

  /* --- Quantity steppers (event delegation) --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var step = btn.dataset.qtyChange === 'up' ? 1 : -1;
    var min = parseInt(input.min || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --- AJAX add to cart --- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var originalText = button.textContent;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.addingText || 'Adding…';

    fetch(window.ccRoutes.cart_add_url + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add to cart');
        return fetch(window.ccRoutes.cart_url + '.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        toast('Added to cart');
      })
      .catch(function (err) {
        toast(err.message, true);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.textContent = originalText;
      });
  });

  /* --- Cart page: change line quantity / remove --- */
  function changeLine(line, quantity) {
    var page = document.querySelector('[data-cart-page]');
    if (page) page.style.opacity = '0.5';

    fetch(window.ccRoutes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        if (page) page.style.opacity = '';
        toast('Could not update cart', true);
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (input) changeLine(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10) || 0);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (btn) {
      e.preventDefault();
      changeLine(parseInt(btn.dataset.lineRemove, 10), 0);
    }
  });

  /* --- Product page: variant selection --- */
  document.querySelectorAll('[data-product-form-wrapper]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var selects = wrapper.querySelectorAll('[data-option-select]');
    var idInput = wrapper.querySelector('[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var button = wrapper.querySelector('[data-add-button]');
    var mediaMain = document.querySelector('[data-main-image]');

    function currentVariant() {
      var options = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function render() {
      var variant = currentVariant();
      if (!variant) {
        button.textContent = 'Unavailable';
        button.setAttribute('disabled', '');
        return;
      }
      idInput.value = variant.id;

      if (priceEl) {
        var html = '';
        if (variant.compare_at_price > variant.price) {
          html = '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
                 '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        } else {
          html = '<span>' + formatMoney(variant.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }

      if (variant.available) {
        button.removeAttribute('disabled');
        button.textContent = button.dataset.addText || 'Add to cart';
      } else {
        button.setAttribute('disabled', '');
        button.textContent = button.dataset.soldoutText || 'Sold out';
      }

      if (variant.featured_image && mediaMain) {
        var img = mediaMain.querySelector('img');
        if (img) { img.src = variant.featured_image.src; img.srcset = ''; }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (s) { s.addEventListener('change', render); });
  });

  /* --- Product page: thumbnail gallery --- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image] img');
    if (!main) return;
    main.src = thumb.dataset.thumb;
    main.srcset = thumb.dataset.thumbSrcset || '';
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* --- Close mobile menu / facets when clicking outside --- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-close-outside][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('details[data-close-outside][open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }
  });

  /* --- Collection sort --- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-by]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* --- Singles browsing: view toggle (Single / 4-up) --- */
  var singlesGrid = document.querySelector('[data-singles-grid]');

  function setSinglesView(view) {
    if (!singlesGrid) return;
    singlesGrid.dataset.view = view;
    try { localStorage.setItem('cc-singles-view', view); } catch (e) { /* private mode */ }
    document.querySelectorAll('[data-view-btn]').forEach(function (btn) {
      var active = btn.dataset.viewBtn === view;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });
  }

  if (singlesGrid) {
    /* sync toggle buttons with the view restored by the inline script */
    document.querySelectorAll('[data-view-btn]').forEach(function (btn) {
      var active = btn.dataset.viewBtn === singlesGrid.dataset.view;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-view-btn]');
      if (btn) setSinglesView(btn.dataset.viewBtn);
    });
  }

  /* --- Singles: quick add from the price chip --- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('button[data-quick-add]');
    if (!add) return;
    e.preventDefault();
    add.disabled = true;

    fetch(window.ccRoutes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(add.dataset.quickAdd, 10), quantity: 1 })
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add to cart');
        return fetch(window.ccRoutes.cart_url + '.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        toast('Added to cart');
      })
      .catch(function (err) {
        toast(err.message, true);
      })
      .finally(function () {
        add.disabled = false;
      });
  });

  /* --- Singles: infinite scroll --- */
  var sentinel = document.querySelector('[data-infinite-sentinel]');
  if (sentinel && singlesGrid && 'IntersectionObserver' in window) {
    var loadMoreLink = sentinel.querySelector('[data-load-more]');
    if (loadMoreLink) loadMoreLink.hidden = true;

    var loadingNext = false;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loadingNext) return;
      var next = sentinel.dataset.nextUrl;
      if (!next) {
        observer.disconnect();
        sentinel.hidden = true;
        return;
      }
      loadingNext = true;
      sentinel.classList.add('is-loading');

      fetch(next)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-singles-grid]');
          if (newGrid) {
            while (newGrid.firstElementChild) singlesGrid.appendChild(newGrid.firstElementChild);
          }
          var newSentinel = doc.querySelector('[data-infinite-sentinel]');
          sentinel.dataset.nextUrl = newSentinel ? newSentinel.dataset.nextUrl || '' : '';
          if (!sentinel.dataset.nextUrl) {
            observer.disconnect();
            sentinel.hidden = true;
          }
        })
        .catch(function () {
          /* network hiccup: fall back to the visible link */
          if (loadMoreLink) loadMoreLink.hidden = false;
          observer.disconnect();
        })
        .finally(function () {
          loadingNext = false;
          sentinel.classList.remove('is-loading');
        });
    }, { rootMargin: '900px 0px' });
    observer.observe(sentinel);
  }

  /* --- Scroll mascot: one card tumbling down the page edge as you scroll --- */
  var mascot = document.querySelector('[data-scroll-mascot]');
  if (mascot && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var mascotTicking = false;
    var updateMascot = function () {
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var p = Math.min(1, window.scrollY / max);
      mascot.style.transform =
        'translateY(' + (p * 64) + 'vh) rotate(' + (p * 540) + 'deg)';
      mascot.style.opacity = p > 0.96 ? '0' : '';
      mascotTicking = false;
    };
    window.addEventListener('scroll', function () {
      if (mascotTicking) return;
      mascotTicking = true;
      requestAnimationFrame(updateMascot);
    }, { passive: true });
    updateMascot();
  }

  /* --- Auto-hide toolbar: hide on scroll down, reveal on scroll up --- */
  var hideBar = document.querySelector('[data-hide-on-scroll]');
  if (hideBar) {
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var delta = y - lastY;
        if (y < 120 || delta < -8) {
          hideBar.classList.remove('is-hidden');
        } else if (delta > 8) {
          hideBar.classList.add('is-hidden');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }
})();
